/**
 * Shared cart snapshot + fingerprint for postcode, preorder, and checkout gate.
 * Reduces duplicate /cart.js fetches while keeping shipping-rate refetch when items change.
 */
(function () {
  'use strict';

  var SNAPSHOT_TTL_MS = 2000;

  var state = {
    cart: null,
    fingerprint: '',
    publishedAt: 0,
    source: ''
  };

  var fetchInFlight = null;

  window.ccComputeCartFingerprint = function (cart) {
    if (!cart) return '';
    var parts = [String(cart.item_count != null ? cart.item_count : 0)];
    if (Array.isArray(cart.items) && cart.items.length) {
      var lines = cart.items
        .map(function (item) {
          var key = item.key != null ? item.key : item.id;
          return String(key) + ':' + String(item.quantity != null ? item.quantity : 0);
        })
        .sort();
      parts.push(lines.join('|'));
    }
    return parts.join('#');
  };

  window.ccPublishCartSnapshot = function (cart, source) {
    if (!cart) return;
    state.cart = cart;
    state.fingerprint = window.ccComputeCartFingerprint(cart);
    state.publishedAt = Date.now();
    state.source = source || '';
  };

  window.ccGetLastCartFingerprint = function () {
    return state.fingerprint;
  };

  window.ccGetCartSnapshot = function (opts) {
    opts = opts || {};
    var force = opts.forceFetch === true;
    var maxAge = opts.maxAgeMs != null ? opts.maxAgeMs : SNAPSHOT_TTL_MS;

    if (!force && state.cart && Date.now() - state.publishedAt < maxAge) {
      return Promise.resolve(state.cart);
    }

    if (fetchInFlight) return fetchInFlight;

    var url = (window.theme && window.theme.routes && window.theme.routes.cart) || '/cart';
    fetchInFlight = fetch(url + '.js')
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (cart) {
        if (cart) window.ccPublishCartSnapshot(cart, 'ccGetCartSnapshot');
        return cart;
      })
      .catch(function () {
        return null;
      })
      .finally(function () {
        fetchInFlight = null;
      });

    return fetchInFlight;
  };

  /**
   * Publish snapshot and dispatch on:cart:change with cart + fingerprint on detail.
   * @param {object} detail
   */
  window.ccDispatchCartChange = function (detail) {
    detail = detail || {};
    if (detail.cart) {
      window.ccPublishCartSnapshot(detail.cart, detail.source || 'dispatch');
      if (!detail.cartFingerprint) {
        detail.cartFingerprint = window.ccComputeCartFingerprint(detail.cart);
      }
      detail.cartUpdated = detail.cartUpdated !== false;
    }
    document.dispatchEvent(
      new CustomEvent('on:cart:change', {
        bubbles: true,
        detail: detail
      })
    );
  };

  var flarePostRenderTimer;

  /** Debounced Flare label + calendar surcharge refresh after section HTML swaps. */
  window.ccScheduleFlarePostRender = function () {
    clearTimeout(flarePostRenderTimer);
    flarePostRenderTimer = setTimeout(function () {
      if (window.replaceFlareBrandWithText) window.replaceFlareBrandWithText();
      if (window.startFlareCalendarSurchargeObserver) window.startFlareCalendarSurchargeObserver();
      if (window.hideFlareInlineDateSurchargeDisplay) window.hideFlareInlineDateSurchargeDisplay();
      if (window.ensureFlareDatePickerChrome) window.ensureFlareDatePickerChrome();
    }, 100);
  };
})();
